<template>
  <footer>
    <div class="info">
      <div class="top-footer">
        <div class="logo">
          <img src="@/assets/images/logo-full.svg" alt="" />
        </div>
        <div class="information">
          <h4>Sídlo</h4>

          <p>
            H&G Solution s.r.o. <br />
            Revišné 322, Veličná 027 54
          </p>
          <p>IČO: 52 183 114, DIČ: 2120919394</p>
          <p>IČ DPH: SK 2120919394</p>

          <h4 class="kancelaria">Kancelária</h4>
          <p>Radlinského 1735/29</p>
          <p>Dolný Kubín 026 01</p>
        </div>
        <div class="important-links">
          <h4>Dôležité odkazy</h4>

          <router-link to="/GDPR">Spracovanie osobných údajov</router-link>
          <a href="https://www.hg-solution.sk/AS/login.php">Prihlásiť sa</a>
          <!-- <router-link to="/bussiness-conditions"
            >Obchodné podmienky</router-link
          > -->
        </div>
      </div>
      <div class="bottom-footer">
        <p class="copyright">© 2022 Všetky práva vyhradené</p>
        <div class="links">
          <a
            target="_blank"
            href="https://www.facebook.com/people/HG-Solution/100067480704979/?paipv=0&eav=Afa_v9-sMLSYyqqs69D9Le8nR0qZQsxU0xv21ZIAg6yQPap7JZ9GItZ1JQUX5GGERWQ&_rdr"
            ><img src="@/assets/images/facebookIcon.svg" alt=""
          /></a>
          <!-- <a href="#" target="_blank"><img src="@/assets/images/instagramIcon.svg" alt="" /></a> -->
          <a href="mailto:info@hg-solution.sk"
            ><img src="@/assets/images/mailIcon.svg" alt=""
          /></a>
          <a
            target="_blank"
            href="https://www.google.com/maps?ll=49.221963,19.237037&z=10&t=m&hl=en&gl=US&mapclient=embed&q=Revi%C5%A1n%C3%A9+322+027+54+Veli%C4%8Dn%C3%A1"
            ><img src="@/assets/images/mapIcon.svg" alt=""
          /></a>
        </div>
      </div>
    </div>
    <div class="navigation">
      <h4>Navigácia</h4>

      <ul>
        <li><router-link to="/">Úvod</router-link></li>
        <li><router-link to="/about-us">O nás</router-link></li>
        <li><router-link to="/services">Služby</router-link></li>
        <li><router-link to="/how-works">Ako to funguje</router-link></li>
        <li><router-link to="/help">Poradíme vám</router-link></li>
        <li><router-link to="/make-cv">Vytvoriť životopis</router-link></li>
        <li>
          <router-link to="/current-offers">Aktuálne ponuky</router-link>
        </li>
        <li>
          <router-link to="/realized-projects"
            >Realizované projekty</router-link
          >
        </li>
        <li><router-link to="/contact">Kontakt</router-link></li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
// IMPORT COLORS
@import "@/assets/sass/_colors.scss";

footer {
  background: $grey-color;
  color: $text-invert-color;
  padding: 1em 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 1.05em;

  h4 {
    color: rgba(87, 87, 87, 1);
    font-size: 1em;
  }

  .info {
    width: 80%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .navigation {
    width: 15%;

    text-align: right;
    padding-right: 5%;

    ul {
      padding-left: 0;
      list-style-type: none;

      li {
        margin-bottom: 0.4em;
        text-align: left;
        a {
          color: $text-invert-color;
          text-decoration: none;
        }
      }
    }

    h4 {
      text-align: left;
    }
  }
}

.information p {
  margin: 0.5em 0;
}

.top-footer {
  display: flex;
  flex-direction: row;

  justify-content: space-evenly;

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1em;

    img {
      width: 10em;
    }
  }

  .important-links {
    display: flex;
    flex-direction: column;

    a {
      color: $text-invert-color;
      text-decoration: none;
      margin-bottom: 0.5em;
    }
  }
}

.bottom-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 1em 5%;

  .links {
    padding-right: 27.5%;
    display: flex;
    align-items: center;

    a img {
      height: 1.4em;
      padding: 0.5em;
    }

    a:nth-child(2) img {
      height: 1.2em;
    }
  }
}

.router-link-active {
  font-weight: 700;
}

.kancelaria {
  margin: 1em 0 0;
}

@media screen and (max-width: 900px) {
  .navigation {
    display: none;
  }

  footer .info {
    width: 100%;
    font-size: 90%;
  }
  .bottom-footer .links {
    padding-right: 0;
  }
}

@media screen and (max-width: 690px) {
  .top-footer,
  .bottom-footer {
    flex-direction: column;
    text-align: center;

    .links {
      justify-content: center;
    }
  }
}
</style>
